import Image from 'next/image';
import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';
import React from 'react';

const PRESET_IMAGES: Record<string, string> = {
  'ai-images': '/images/ai-images-new.jpg',
  tts: '/images/text-to-speech.png',
  audios: '/images/ai-transcription.jpg',
  chat: '/images/cta-image4.png',
  templates: '/images/presets3.jpg',
  bots: '/images/bot-management.jpg',
  'ai-interior-designer': '/images/interior-designer.png',
};

const DEFAULT_CTA_IMAGE = '/images/cta-image3.png';

const CallToAction = ({ preset = '', href: hrefOverride = '' }) => {
  const { t } = useLocale('footer');

  return (
    <div className='bg-white dark:bg-slate-800'>
      <div className='mx-auto max-w-7xl sm:px-6 sm:py-32 lg:px-8'>
        <div className='relative isolate overflow-hidden bg-gray-900 px-6 pt-16 shadow-2xl sm:rounded-3xl sm:px-16 md:pt-24 lg:flex lg:gap-x-20 lg:px-24 lg:pt-0'>
          <svg
            viewBox='0 0 1024 1024'
            className='absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-y-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] sm:left-full sm:-ml-80 lg:left-1/2 lg:ml-0 lg:-translate-x-1/2 lg:translate-y-0'
            aria-hidden='true'
          >
            <circle
              cx={512}
              cy={512}
              r={512}
              fill='url(#759c1415-0410-454c-8f7c-9a820de03641)'
              fillOpacity='0.7'
            />
            <defs>
              <radialGradient id='759c1415-0410-454c-8f7c-9a820de03641'>
                <stop stopColor='#7775D6' />
                <stop offset={1} stopColor='#E935C1' />
              </radialGradient>
            </defs>
          </svg>
          <div className='mx-auto max-w-md text-center lg:mx-0 lg:flex-auto lg:py-32 lg:text-start'>
            <h2 className='text-3xl font-bold tracking-tight text-white sm:text-4xl'>
              {t('Create Faster With AI.')}
              <br />
              {t('Try it Risk-Free.')}
            </h2>
            <p className='mt-6 text-lg leading-8 text-gray-300'>
              {t(
                'Stop wasting time and start creating high-quality content immediately with power of generative AI.',
              )}
            </p>
            <div className='mt-10 flex items-center justify-center gap-x-6 lg:justify-start'>
              <Link
                href={
                  hrefOverride ||
                  (preset
                    ? `/login?preset=${encodeURIComponent(preset)}#auth-sign-up`
                    : '/login#auth-sign-up')
                }
                className='rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white'
              >
                {t('Get started for free')}
              </Link>
            </div>
          </div>
          <div className='relative mt-16 h-80 lg:mt-8'>
            <Image
              className='absolute start-0 top-0 w-[47rem] max-w-none rounded-md bg-white/5 ring-1 ring-white/10'
              src={PRESET_IMAGES[preset] || DEFAULT_CTA_IMAGE}
              alt='App screenshot'
              width={1824}
              height={1080}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
